import React from "react";

type JournalErrorBoundaryProps = {
  name: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type JournalErrorBoundaryState = { hasError: boolean };

export class JournalErrorBoundary extends React.Component<
  JournalErrorBoundaryProps,
  JournalErrorBoundaryState
> {
  constructor(props: JournalErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): JournalErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(this.props.name, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? <div className="journal-message">Error loading journal question</div>
      );
    }
    return this.props.children;
  }
}
